export default function Privacy() {
  return (
    <div className="py-12">
      <div className="mt-5 mx-auto px-4 sm:mt-12 sm:px-6 md:mt-6 lg:mt-10 lg:px-8 xl:mt-5">
        <h1 className="text-xl tracking-tight font-bold text-gray-500 sm:text-5xl md:text-4xl">
          <span className="block xl:inline">Privacy Policy</span>
        </h1>
        <p className="text-base text-gray-500 sm:mt-5 sm:text-lg">
          Your privacy and security is very important to us at Holla Labs LTD,
          the owner and operator of www.frendzy.app and the Frendzy mobile App
          (“Frendzy”, “we”, or “us”).  Frendzy does not sell, rent or lease your
          personal information to third parties.  If we share information about
          our users for any of the purposes included in this Privacy Policy it
          is in an aggregated or anonymized form which cannot reasonably be used
          to identify you unless you agree otherwise. This Privacy Policy
          explains how we collect, use, share and protect information about the
          users of our mobile App and our Websites (collectively referred to as
          “user” or “you”). Frendzy collects information about you when you use
          our mobile application (&quot;App&quot;) or the Websites
          (&quot;Website&quot; or &quot;Site&quot;) that allow you to access our
          services, and other online products and services (collectively, the
          “Services”) and through other interactions and communications you have
          with us. The term Services includes, collectively, various
          applications, websites, widgets, email notifications and other
          mediums, or portions of such mediums, through which you have accessed
          this Privacy Policy. By accessing or using our Services, you consent
          to the collection, transfer, manipulation, storage, disclosure and
          other uses of Your Information (collectively, &quot;Use of Your
          Information&quot;) as described in this Privacy Policy. For purposes
          of this Privacy Policy, &quot;Your Information&quot; means information
          about you, which may be of a confidential or sensitive nature and may
          include personally identifiable information (&quot;PII&quot;) and/or
          financial information. PII means individually identifiable information
          that would allow us to determine the actual identity of a specific
          living person, while sensitive data may include information, comments,
          content and other information that you voluntarily provide.
        </p>
        <p className="text-base text-gray-500 sm:mt-5 sm:text-lg">
          <ol>
              <h2 className="font-bold">Application</h2>
            <li>
              1. This Privacy Policy (“Privacy Policy&quot;) applies
              to persons and businesses anywhere in the world that use our
              Services. By accessing and using the Services we offer, you are
              agreeing to be bound by this Privacy Policy in respect of the
              information collected about you.
            </li>
            <h2 className="font-bold">How We Collect Information</h2>
            <li>
               2. Information You Provide To Us   We collect information you
              provide directly to us, such as when you request information,
              create or modify your personal account, request Services, complete
              a Frendzy form or application, contact customer support, make a
              purchase or otherwise communicate with us. This information may
              include, without limitation: name, date of birth, e-mail address,
              physical address, business address, phone number, newsletter
              preference or other personal information you choose to provide. We
              will only request information that is needed to provide you with
              our services. You always have the opportunity to add or edit your
              own Personal Data either through your profile settings in the app
              itself or by contacting Frendzy at hello@frendzy.app.
            </li>
            <li>
              3. Information We Collect Through Your Use of Our Services The
              following are situations in which you may provide Your Information
              to us:
              <ul>
                <li>
                  a. When you fill out forms or fields through our Services;
                </li>
                <li>b. When you register for an account with our Services;</li>
                <li>
                  c. When you order products from, or through our Services;
                </li>
                <li>
                  d. When you sign up for any newsletters or other materials
                  through our Services;
                </li>
                <li>
                  e. When you provide information to us through a third-party
                  application, service or Website;
                </li>
                <li>
                  f. When you communicate with us or request information about
                  us or our Services, whether via email or other means;
                </li>
                <li>g. When you participate in online surveys;</li>
                <li>
                  h. When you participate in any of our marketing initiatives,
                  including, contests, events, or promotions; and
                </li>
                <li>
                  i. When you participate in forums, reviews or provide user
                  generated content or other submissions.{" "}
                </li>
              </ul>
            </li>
            <p>
              We also automatically collect information via the Website or App
              through the use of various technologies, including, but not
              limited to cookies and pixel tags. We will always ask your consent
              before collecting personally identifiable information. We may
              collect your IP address, browsing behavior and device IDs. This
              information is used by us in order to enable us to better
              understand how our Services are being used by visitors and allows
              us to administer and customize the Services to improve your
              overall experience. We will only collect information that is
              relevant to the services we provide and will never accumulate
              unnecessary personal data. 
            </p>
            The following is a list of information that we may collect about
            you:
            <ul>
              <li>a. Your name</li>
              <li>b. Your email address</li>
              <li>c. Your birthday</li>
              <li>d. Your location</li>
              <li>e. Your gender</li>
              <li>f. Your education</li>
              <li>g. Your work</li>
              <li>h. Languages you speak</li>
              <li>i. Your marital status</li>
              <li>j. Your interests</li>
              <li>k. The device you are using</li>
              <li>
                l. Certain behaviors about how you interact with our services
              </li>
            </ul>
            <li>
              4. Log Files, Cookies and Anonymous Identifiers
              <ul>
                <li>
                  a. We collect information about how you interact with our
                  Services, preferences expressed, and settings chosen. We
                  gather certain information automatically and store it in log
                  files.  This information may include internet protocol (IP)
                  addresses, browser type, internet service provider (ISP),
                  referring/exit pages, operating system, date/time stamp,
                  and/or clickstream data. We may combine this automatically
                  collected log information with other information we collect
                  about you. We do this to improve services we offer to you, to
                  improve marketing, analytics, or App/Site functionality, and
                  to document your consent to receiving products, services or
                  communications from us or our partners. If we link such
                  information with personally identifiable information in a
                  manner that identifies a particular individual, then we will
                  treat all such information as personally identifiable
                  information for purposes of this Privacy Policy.
                </li>
                <li>
                  b. Technologies such as cookies (a small file placed on your
                  device), pixel tags, web beacons, touch heatmaps, user
                  recordings, crash videos, scripts and similar technologies
                  that create and maintain unique identifiers are used by us and
                  our partners, affiliates, advertisers, analytics teams, or
                  service providers. These technologies are used in analyzing
                  trends, administering the Site, tracking users’ movements
                  around the Site, and gathering demographic information about
                  our userbase as a whole. We may receive reports based on the
                  use of these technologies by these companies on an individual
                  as well as aggregated basis.
                </li>
                <li>
                  c. We use cookies to help us know that you are logged on, to
                  provide you with features based on your preferences, to
                  understand when you are interacting with our Services, and to
                  compile other information regarding use of our Services.
                </li>
                <li>
                  d. Third parties with whom we partner to provide certain
                  features on our Site or to display advertising based upon your
                  Web browsing activity use cookies to collect and store
                  information.
                </li>
                <li>
                  e. Our website may use remarketing services, such as Google
                  AdWords and Facebook, to advertise on third party websites to
                  previous visitors to our Site. It could mean that we advertise
                  to previous visitors who have not completed a task on our
                  site. This could be in the form of an advertisement on the
                  Google search results page, a site in the Google Display
                  Network, or somewhere on Facebook. Third-party vendors,
                  including Google and Facebook, use cookies to serve ads based
                  on your past visits to our Website. Any data collected will be
                  used in accordance with our own privacy policy, as well as
                  Google &amp; Facebook privacy policies. You can opt-out of
                  remarketing by visiting the links below: For Google:
                  https://support.google.com/ads/answer/2662922?hl=en For
                  Facebook: 
                  https://www.facebook.com/ads/website_custom_audiences/
                </li>
                <li>
                  f. You can control the use of cookies at the individual
                  browser level. If you reject cookies, you may still use our
                  Site, but your ability to use some features or areas of our
                  Site may be limited.
                </li>
                <li>
                  g. Frendzy cannot control the use of cookies by third parties
                  (or the resulting information), and use of third party cookies
                  is not covered by this policy.{" "}
                </li>
              </ul>
            </li>
            <li>
              5. Information We Collect From Other Sources We may also receive
              information from other sources and combine that with information
              we collect through our Services. For example, if you choose to
              link, create, or log in to your Frendzy account with a social
              media service, e.g. Facebook, or a payment provider, e.g. Apple
              Pay or Google Wallet, or if you engage with a separate App or
              Website that uses our API, or whose API we use, we may receive
              information about you or your connections from that Site or App.
            </li>
            <li>
              6. Information Third Parties Provide We may collect information
              about you from sources other than you, such as from social media
              websites (i.e., Facebook, LinkedIn, Twitter or others), blogs,
              other users and our business partners.
            </li>
            <li>
              7. Location Information When you use the Services, we may collect
              your precise location data. We may also derive your approximate
              location from your IP address.{" "}
            </li>
            <li>
              8. Device Information When you use our Services through your
              computer, mobile phone or other device, we may collect information
              regarding and related to your device, such as hardware models and
              IDs, device type, operating system version, the request type, the
              content of your request and basic usage information about your use
              of our Services, such as date and time. In addition, we may
              collect information regarding application-level events and
              associate that with your account to provide customer service. We
              may also collect and store information locally on your device
              using mechanisms such as browser web storage and application data
              caches. Information We Do Not Collect
            </li>
            <li>
              10. Information We Do Not Collect Through Your Use of Our Services
              We do not collect or store payment information, including
              credit/debit card details or billing information. However, we may
              facilitate the transfer of your payment information to third party
              payment processor gateways. All payments are handled by the third
              party secure payment provider gateway. How We Protect Your
              Information
            </li>
            <li>
              11. Protective Measures We will take all steps reasonably
              necessary to ensure that your Personal Data is treated securely
              and in accordance with this Privacy Policy. All Personal Data
              provided to us is stored on secure servers using commercially
              reasonable technical and administrative security measures to
              reduce the risks of loss, misuse, unauthorized access, disclosure
              and alteration. Unfortunately, the transmission of any information
              via the internet, e-mail and other mobile networks is not entirely
              secure. Although we will do our best to protect your Personal
              Data, we cannot guarantee the security of the Personal Data
              transmitted to the Website. Any transmission is at your own risk.
              However, once we have received your Personal Data, we will use
              strict procedures and security features to try to prevent
              unauthorized access.
            </li>
            <li>
              12.Children&#39;s Privacy The Site and Services are intended for
              users who are at least 18 years of age. Furthermore, we do not
              knowingly collect Personal Information from persons under the age
              of
            </li>
            <li>
              13. If you are under the age of 13, please do not provide us with
              information of any kind whatsoever. We encourage parents and
              guardians to spend time with their children online and to be
              familiar with the websites they visit and the Apps they use. If
              you have reason to believe that we may have accidentally received
              information from a child under the age of 13, please contact us
              immediately at hello@frendzy.app. If we become aware that we have
              inadvertently received Personal Information from a person under
              the age of 13, we will delete such information from our records.
              How We Use Information 13.  Generally We do not sell your
              personally identifiable information (Your Information) to third
              parties. Our primary purpose in collecting Your Information is to
              provide you with a safe, smooth, efficient, and customized
              experience. Additionally, we use non-personally identifiable
              information that we aggregate to better design our website and to
              share with advertisers. Any data that we may sell is in an
              aggregated and/or anonymized form which cannot reasonably be used
              to identify you. This information is used to provide
              friend-matching services and can be deleted at any time when you
              choose to deactivate your account. In the event of longer
              inactivity, we will erase data on a regular periodic basis. Some
              data may be necessary to keep for longer periods of time to
              fulfill contracts and/or legal requirements but whenever possible,
              will be anonymized.
            </li>
            <li>
              14. Services We will use this information in order to:
              <ul>
                <li>
                  a. Provide users with our Services and customer support
                  including, but not limited to, confirming emails related to
                  our services, reminders, confirmations, requests for
                  information and transactions.
                </li>
                <li>b. Contact you and provide you with information.</li>
                <li>
                  c. Analyze, improve, and manage our Services and operations.
                </li>
                <li>
                  d. Resolve problems and disputes, and engage in other legal
                  and security matters.
                </li>
                <li>
                  {" "}
                  e. Enforce our Terms of Service. Additionally, we may use the
                  information we collect about you to:{" "}
                  <ul>
                    <li>
                      a. Send you communications we think will be of interest to
                      you, including information about products, services,
                      promotions, news, and events of Frendzy and other
                      companies, where permissible and according to local
                      applicable laws.
                    </li>
                    <li>
                      b. Display advertising, including advertising that is
                      targeted to you based on your location, interests, as well
                      as your Frendzy activities.
                    </li>
                    <li>
                      c. Verify your identity and prevent impersonation, spam or
                      other unauthorized or illegal activity including, without
                      limitation, infringement of intellectual property rights
                      of third parties.
                    </li>
                    <li>
                      d. We may transfer the information described in this
                      Privacy Policy to, and process and store it in, the United
                      States and other countries, some of which may have less
                      protective data protection laws than the region in which
                      you reside. Where this is the case, we will, to the best
                      of our abilities, take measures to protect your personal
                      information in accordance with this Privacy Policy,
                      however we will not be responsible for the differing data
                      protection laws and its effect on our users.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              15. Sharing Of Information
              <ul>
                <li>
                  a. We may share the information we collect about you as
                  described in this Privacy Policy or as described at the time
                  of collection or sharing, including as follows:
                  <ul>
                    <li>
                      i) with third party Service Providers to enable them to
                      provide the Services you request;
                    </li>
                    <li>
                      ii) with the general public if you submit content in a
                      public forum, your reviews, comments or other features of
                      our Services that are viewable by the general public; and
                    </li>
                    <li>
                      iii) with third parties with whom you choose to let us
                      share information, for example other Apps or Websites that
                      integrate with our API or Services, or those with an API
                      or service with which we integrate.
                    </li>
                  </ul>
                </li>
                <li>
                  b. We may disclose Your Information:
                  <ul>
                    <li>
                      i) To any person who, in our reasonable judgment, is
                      authorized to receive Your Information as your agent,
                      including as a result of your business dealings with that
                      person (for example, your attorney);
                    </li>
                    <li>
                      ii) To our third-party vendors and service providers so
                      that they may provide support for our internal and
                      business operations, including for the processing of
                      payments, handling of data processing, data verification,
                      data storage, surveys, research, internal marketing,
                      delivery of promotional, marketing and transaction
                      materials, and maintenance of our Services and security.
                      These companies are authorized to use Your Information
                      only as necessary to provide these services to us and are
                      contractually obligated to keep Your Information
                      confidential;
                    </li>
                    <li>
                      iii) To third parties when you engage in certain
                      activities through our Services that are sponsored by
                      them, such as purchasing products or services offered by a
                      third party, electing to receive information or
                      communications from a third party, or electing to
                      participate in contests, sweepstakes, games or other
                      programs sponsored, in whole or in part, by a third party.
                      When we disclose Your Information to these third parties,
                      Your Information will become subject to the information
                      use and sharing practices of the third party, and the
                      third party will not be restricted by this Privacy Policy
                      with respect to its use and further sharing of Your
                      Information;
                    </li>
                    <li>
                      iv) As required by law or ordered by a court, regulatory,
                      or administrative agency;
                    </li>
                    <li>
                      v) As we deem necessary, in our sole discretion, if we
                      believe that you are violating any applicable law, rule or
                      regulation, or are otherwise interfering with
                      another&#39;s rights or property, including, without
                      limitation, our rights or property;
                    </li>
                    <li>
                      vi) If requested by authorities in the event of any act of
                      terrorism or instance of local, regional or national
                      emergency; vii)       To enforce our Terms of Service,
                      this Privacy Policy, and any other applicable agreements
                      and policies; viii)     To enforce or protect our rights.
                      c.   We will only transfer data outside of the EU to
                      countries that offer an appropriate level of data
                      protection.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              16. Law Enforcement
              <ul>
                <li>
                  a. Frendzy is committed to cooperating with law enforcement
                  while respecting each individual’s right to privacy. If
                  Frendzy receives a request for user account information from a
                  government agency investigating criminal activity, we will
                  review the request to be certain that it satisfies all legal
                  requirements before releasing information to the requesting
                  agency.
                </li>
                <li>
                  b. Furthermore, under 18 U.S.C. §§ 2702(b)(8) and 2702(c)(4)
                  (Voluntary Disclosure Of Customer Communications or Records),
                  Frendzy may disclose user account information to law
                  enforcement, without a subpoena, court order, or search
                  warrant, in response to a valid emergency when we believe that
                  doing so is necessary to prevent death or serious physical
                  harm to someone. Frendzy will not release more information
                  than it prudently believes is necessary to prevent harm in an
                  emergency situation.
                </li>
                <li>
                  17. Other Sharing We may share your information as follows:
                  <ul>
                    <li>
                      a. With Frendzy subsidiaries and affiliated entities that
                      provide services or conduct data processing on our behalf,
                      or for data verification, data centralization and/or
                      logistics purposes;
                    </li>
                    <li>
                      b. With affiliated entities that provide payment
                      processing services on our behalf;
                    </li>
                    <li>
                      c. With vendors, consultants, marketing partners, and
                      other service providers who need access to such
                      information to carry out work on our behalf;
                    </li>
                    <li>
                      d. In response to a request for information by a competent
                      authority if we believe disclosure is in accordance with,
                      or is otherwise required by, any applicable law,
                      regulation, or legal process;
                    </li>
                    <li>
                      e. With law enforcement officials, government authorities,
                      or other third parties if we believe your actions are
                      inconsistent with our user agreements, Terms of Service,
                      or policies, or to protect the rights, property, or safety
                      of Frendzy or others;
                    </li>
                    <li>
                      f. In connection with, or during negotiations of, any
                      merger, sale of company assets, consolidation or
                      restructuring, financing, or acquisition of all or a
                      portion of our business by or into another company;
                    </li>
                    <li>
                      g. If we otherwise notify you and you consent to the
                      sharing; and
                    </li>
                    <li>
                      h. In an aggregated and/or anonymized form which cannot
                      reasonably be used to identify you.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              18. Social Sharing Features
              <ul>
                <li>
                  a. Our Services may now or in the future integrate with social
                  sharing features and other related tools which let you share
                  actions you take on our Services with other Apps, sites, or
                  media, and vice versa. Your use of such features enables the
                  sharing of information with your friends or the public,
                  depending on the settings you establish with the social
                  sharing service. Please refer to the privacy policies of those
                  social sharing services for more information about how they
                  handle the data you provide to or share through them.
                </li>
                <li>
                  b. Any information or content that you voluntarily disclose
                  for posting publicly to our Services or the social sharing
                  service becomes available to the public, as controlled by any
                  applicable privacy settings that you set within the social
                  sharing service. Once you have shared User Content or made it
                  public, that User Content may be re-shared by others. If you
                  remove information that you posted to our Services or the
                  social sharing service, copies may still remain viewable in
                  cached and archived pages, or if other users or third parties,
                  using our Services or the social sharing service, have
                  re-shared, copied or saved that User Content.
                </li>
              </ul>
            </li>
            <li>
              19. Analytics and Advertising Services Provided By Others We may
              allow others to provide audience measurement and analytics
              services for us, to serve advertisements on our behalf across the
              Internet, and to track and report on the performance of those
              advertisements. These entities may use cookies, web beacons,
              software development kits (SDKs), and other technologies to
              identify your device when you visit our Site and use our Services,
              as well as when you visit other online sites and services.
            </li>
            <li>
              20. Links to Third Party Websites
              <ul>
                <li>
                  a. Our Services, as well as the email messages sent with
                  respect to our Services, may contain links or access to
                  websites operated by third parties that are beyond our
                  control. Links or access to third parties from our Services
                  are not an endorsement by us of such third parties, or their
                  websites, applications, products, services, or practices. We
                  are not responsible for the privacy policy, terms and
                  conditions, practices or the content of such third parties.
                  These third parties may send their own cookies to you and
                  independently collect data.
                </li>
                <li>
                  b. If you visit or access a third-party Website, application
                  or other property that is linked or accessed from our
                  Services, we encourage you to read any privacy policies and
                  terms and conditions of that third party before providing any
                  personally identifiable information. If you have a question
                  about the terms and conditions, privacy policy, practices or
                  contents of a third party, please contact the third party
                  directly.
                </li>
              </ul>
            </li>
            <li>
              21. Do Not Track Some web browsers may give you the ability to
              enable a &quot;do not track&quot; feature that sends signals to
              the websites you visit, indicating that you do not want your
              online activities tracked. This is different than blocking or
              deleting cookies, as browsers with a &quot;do not track&quot;
              feature enabled may still accept cookies. There is currently no
              industry standard for how companies should respond to &quot;do not
              track&quot; signals, although one may develop in the future. We do
              not respond to &quot;do not track&quot; signals at this time; if
              we do so in the future, we will describe how in this Privacy
              Policy.
            </li>
            <li>
              22. International Privacy Practices In order to provide our
              products and services to you, we may send and store your personal
              information outside of the country where you reside or are
              located, including to the United States. Accordingly, if you
              reside or are located outside of the United States, your personal
              information may be transferred outside of the country where you
              reside or are located, including countries that may not, or do
              not, provide the same level of protection for your personal
              information. We are committed to protecting the privacy and
              confidentiality of personal information when it is transferred. If
              you reside or are located within the European Economic Area and
              such transfers occur, we take appropriate steps to provide the
              same level of protection for the processing carried out in any
              such countries as you would have within the European Economic Area
              to the extent feasible under applicable law. By using and
              accessing our products and services, users who reside or are
              located in countries outside of the United States agree and
              consent to the transfer to and processing of personal information
              on servers located outside of the country where they reside, and
              that the protection of such information may be different than
              required under the laws of their residence or location.
            </li>
            <li>
              23. Account Information You may correct your account information
              at any time by logging into your online account and selecting the
              deletion option. Please note that in some cases we may retain
              certain information about you as required by law, or for
              legitimate business purposes to the extent permitted by law. For
              instance, if you have a standing credit or debit on your account,
              or if we believe you have committed fraud or violated our Terms of
              Service, we may seek to resolve the issue before deleting your
              information. Your Preferences
            </li>
            <li>
              24. Access Rights Frendzy will comply with individuals’ requests
              regarding access, correction, and/or deletion of the personal data
              it stores in accordance with applicable law. To make changes to
              your account affecting your personal information, please login to
              your online account and select app settings / profile settings. At
              any time, upon request, Frendzy will provide you with access to
              your data and how it is being used, and can deliver your data to
              you or a requested third-party. If you wish to exercise this right
              please contact hello@frendzy.app.
            </li>
            <li>
              25. Promotional Information Opt Out You may opt out of receiving
              promotional messages from us by following the instructions in
              those messages. If you opt out, we may still send you
              non-promotional communications regarding your account, about
              Services you have requested, or about our ongoing business
              relations.
            </li>
            <li>
              26. Changes to the Privacy Policy We may change this Privacy
              Policy from time to time. If we decide to change this Privacy
              Policy, we will inform you by posting the revised Privacy Policy
              on the Site. Those changes will go into effect on the &quot;Last
              updated&quot; date shown below. By continuing to use the Site or
              Services, you consent to the revised Privacy Policy. We encourage
              you to periodically review the Privacy Policy for the latest
              information on our privacy practices.
            </li>
            <li>
              27. Contact Us If you have any questions about this Privacy
              Policy, please contact us at hello@frendzy.app
            </li>
          </ol>
        </p>
      </div>
    </div>
  );
}
